import { render } from "./SingleCourseModule.vue?vue&type=template&id=4d02d388"
import script from "./SingleCourseModule.vue?vue&type=script&lang=js"
export * from "./SingleCourseModule.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__